import React from 'react'
import Main from './Main'

function Resume() {
    return (
        <>
            <Main active="resume">
               <div className="main">
                    <section id="resume" className="resume">
                    <div className="container">

                        <div className="section-title">
                            <h2>Experience</h2>
                            <p style={{"fontSize" : "18px"}}>Software engineer with over 4 years of experience in multiple web
                                based technologies in the design, development, and testing phases
                                of the software development lifecycle. Performed 6 months internship
                                prior to permanent employment.
                            </p>
                        </div>

                        <div className="row">
                        <div className="col-lg-6">
                            <h3 className="resume-title">PROJECTS UNDERTAKEN</h3>
                            <div className="resume-item">
                                <h4>SCADA(Supervisory control and data acquisition) - Vedanta</h4>
                                <h5> Dec 2021 - Present</h5>
                                <p><em>system of software platform that allows industrial organizations to control industrial processes locally or at remote locations, 
                                Monitor, gather, and process real-time data</em></p>
                                <strong>Technologies Used :</strong>
                                <p style={{paddingLeft:"10px"}}>HTML, CSS. Javascript, Bootstrap, React, Redux, Node js, Mongodb.</p>
                                <strong>My Role :</strong>
                                <p style={{paddingLeft:"10px"}}>Responsible for backend development which includes designing, planning, researching and developing the core engine of
                                    the project and also frontend development which includes developing
                                    the theme of the project on customer requirement. Performed
                                    customer support via daily meeting, chats, email with client.</p>
                            </div>
                            <div className="resume-item">
                                <h4>VPM (Virtual Project management) - Atkins - Member of the SNC-lavalin Group</h4>
                                <h5> Feb 2021 - Dec 2021</h5>
                                <p><em>Platform made for Atkins by which one manages projects via remote or virtual teams. When teams are distributed across different zones, they still need to get assigned tasks 
                                    and that work must be monitored and tracked to make sure it stays on schedule </em></p>
                                <strong>Technologies Used :</strong>
                                <p style={{paddingLeft:"10px"}}>Java, HTML, CSS. Javascript, Bootstrap, Jquery. Handlebar js.</p>
                                <strong>My Role :</strong>
                                <p style={{paddingLeft:"10px"}}>Responsible for backend development which includes designing, planning, researching and developing the core engine of
                                    the project and also frontend development which includes developing
                                    the theme of the project on customer requirement. Performed
                                    customer support via daily meeting, chats, email with client.</p>
                            </div>
                            <div className="resume-item">
                                <h4>CRM(Customer Relationship Management) System- Keross</h4>
                                <h5>Oct 2020 - Feb 2021</h5>
                                <p><em>It is to be used as an internal organization tool for managing company's relationships and interactions with customer.</em></p>
                                <strong>Technologies Used :</strong>
                                <p style={{paddingLeft:"10px"}}>Java, HTML, CSS. Javascript, Bootstrap, Jquery. Handlebar js, Amcharts js, Mongo </p>
                                <strong>My Role :</strong>
                                <p style={{paddingLeft:"10px"}}>Worked as lead programmer and also involved with both
                                    development and project design. Performed data transformation to
                                    enable analytics and reporting using data visualization framework
                                    (Amcharts js). Performed customer support via daily meeting, chats,
                                    email with client.
                                </p>
                            </div>
                            <div className="resume-item">
                                <h4>Integrated Project Management - Currie & Brown</h4>
                                <h5>May 2020 - Oct 2020</h5>
                                <p><em> It Provides to clients a single system for Project management, Programme management and Portfolio analysis</em></p>
                                <strong>Technologies Used :</strong>
                                <p style={{paddingLeft:"10px"}}>HTML, CSS, Javascript, Bootstrap, Jquery, Handlebar js.</p>
                                <strong>My Role :</strong>
                                <p style={{paddingLeft:"10px"}}>Responsible for frontend development which includes
                                    developing the theme of the project based on customer requirement.
                                </p>
                            </div>
                            <div className="resume-item">
                                <h4>SCM(Supply Chain Management) -  Faithful+Gould</h4>
                                <h5>Jan  2019 - May 2020</h5>
                                <p><em>It is a platform built in IKON framework which provides assurance and reduces risk for a business and their clients</em></p>
                                <strong>Technologies Used :</strong>
                                <p style={{paddingLeft:"10px"}}>Java, HTML, CSS, Javascript, Bootstrap, Jquery, Handlebar js, Amcharts js,  Mongo.</p>
                                <strong>My Role :</strong>
                                <p style={{paddingLeft:"10px"}}>Debugging and fixing bugs in the existing products. Created
                                    documentation for project resources. Performed backend
                                    development which includes researching and developing the core
                                    engine of the project and also frontend development which includes
                                    developing theme of the project based on customer requirement.
                                </p>
                            </div>
                        </div>                            
                        <div className="col-lg-6">
                            <div className="row">
                                <div className="col-12">
                                    <h3 className="resume-title">PROFESSIONAL EXPERIENCE</h3>
                                    <div className="resume-item">
                                        <h4>Team Lead & Full Stack Developer</h4>
                                        <h5>Dec 2021 - Present</h5>
                                        <p><em>Hamilton Research and Technology Pvt Ltd</em></p>
                                        <ul>
                                            <li>Lead project as technical lead which involved supervising project
                                                development, assisting team members, designing code components,
                                                performed risk management, maintained timeline.</li>
                                            <li>Responsible for backend development which includes designing,
                                                planning, researching and developing the core engine of the project
                                                framework.</li>
                                            <li>Responsible for frontend development which includes designing and
                                                developing the UI of the project.</li>
                                            <li>Performed customer support via daily meetings, chat, email with
                                                client.</li>
                                            <li>Created documentation for project resources.</li>  
                                            <li>Debugging and fixing bugs in the existing products.</li>    
                                        </ul>
                                    </div>
                                    <div className="resume-item">
                                        <h4>software Engineer III</h4>
                                        <h5>Jan 2019 - Dec 2021</h5>
                                        <p><em>Keross Research and Development Center | 2019 - Present </em></p>
                                        <ul>
                                            <li>Lead project as technical lead which involved supervising project
                                                development, assisting team members, designing code components,
                                                performed risk management, maintained timeline.</li>
                                            <li>Mentored interns and team members for the IKON platform, and
                                                customer project knowledge transfer</li>
                                            <li>Responsible for backend development which includes designing,
                                                planning, researching and developing the core engine of the project
                                                framework.</li>
                                            <li>Responsible for frontend development which includes designing and
                                                developing the UI of the project.</li>
                                            <li>Performed customer support via daily meetings, chat, email with
                                                client.</li>
                                            <li>Created documentation for project resources.</li>  
                                            <li>Debugging and fixing bugs in the existing products.</li>    
                                        </ul>
                                    </div>
                                    <div className="resume-item">
                                        <h4>Technical Intern</h4>
                                        <h5>Jul 2018 – Dec 2018</h5>
                                        <p><em>Keross Research and Development Center | 2018 </em></p>
                                        <ul>
                                            <li>Debugging and fixing bugs in the existing products.</li>
                                            <li>Responsible for backend and frontend development.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <h3 className="resume-title">PERSONAL PROJECT</h3>
                                    <div className="resume-item">
                                        <h4>Image Shrink</h4>
                                        <p><em>It is used to reduce picture size without losing quality. It can be used
                                        on different situations, for example 
                                        <ul>
                                            <li>Posting Photos on forum</li>
                                            <li>Sending Images as email attachments</li>
                                            <li>Posting photo on blog</li>
                                            <li>Including pictures within word or pdf document</li>
                                        </ul>
                                        </em></p>
                                        <strong>Technologies Used :</strong>
                                        <p style={{paddingLeft:"10px"}}>Javascript, NPM, Electron js, HTML, CSS, Materialize CSS</p>
                                    </div>
                                    <div className="resume-item">
                                        <h4>Personal Portfolio</h4>
                                        <p><em>It's an ongoing project that is used to show all details about me and my completed projects.</em></p>
                                        <strong>Technologies Used :</strong>
                                        <p style={{paddingLeft:"10px"}}>React js, Express js, gits, NPM, bootstrap, HTML, CSS</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        </div>

                    </div>
                    </section>
               </div>
              </Main> 
        </>
    )
}

export default Resume
